// src/context/ChatbotContext.jsx
import React, { createContext, useContext, useState } from "react";

const ChatbotContext = createContext(null);

export const ChatbotProvider = ({ children }) => {
  const [message, setMessage] = useState("");
  const [listening, setListening] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [isLeftAligned, setIsLeftAligned] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const [currentCube, setCurrentCube] = useState(null);
  const [currentCubeLabel, setCurrentCubeLabel] = useState(null);
  const [availableCubes, setAvailableCubes] = useState([]);
  const [waitingForCubeSelection, setWaitingForCubeSelection] = useState(false);
  const [loading, setLoading] = useState(false);
  const [copiedIdx, setCopiedIdx] = useState(null);

  const value = {
    message,
    setMessage,
    listening,
    setListening,
    messages,
    setMessages,
    isOpen,
    setIsOpen,
    isMaximized,
    setIsMaximized,
    isLeftAligned,
    setIsLeftAligned,
    threadId,
    setThreadId,
    currentCube,
    setCurrentCube,
    currentCubeLabel,
    setCurrentCubeLabel,
    availableCubes,
    setAvailableCubes,
    waitingForCubeSelection,
    setWaitingForCubeSelection,
    loading,
    setLoading,
    copiedIdx,
    setCopiedIdx,
  };

  return <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>;
};

export const useChatbot = () => {
  const ctx = useContext(ChatbotContext);
  if (!ctx) throw new Error("useChatbot must be used within ChatbotProvider");
  return ctx;
};